import { createIcon } from "@chakra-ui/icons";

// Created from revoke-arrow.svg

export const RevokeIcon = createIcon({
  displayName: "Revoke icon",
  viewBox: "0 0 18 21",
  path: (
    <path
      d="M0.499986 5.6981L10.1918 10.7494L10.1918 8.3321C11.2614 8.22086 13.8611 10.0035 13.7571 12.4992C13.4719 19.3446 4.56251 20.9371 0.499985 20.6995C4.44366 21.2937 13.5254 20.8323 16.9659 13.5689C20.1747 6.79474 13.9948 3.66403 10.1918 3.16822L10.1918 0.421684L0.499986 5.6981Z"
      fill="currentColor"
    />
  ),
});
